import { useQuery } from '@tanstack/react-query';
import { adminService } from '../../services/api/adminService';

export function useAnalyticsQuery() {
  return useQuery({
    queryKey: ['admin', 'analytics'],
    queryFn: () => adminService.getAnalytics(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false
  });
}
